var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18V0H1.5V1.5H12.5V0H14V18H12.5V16.5H1.5V18H0ZM1.5 8.25H3V4.75H8V8.25H12.5V3H1.5V8.25ZM1.5 15H6V11.5H11V15H12.5V9.75H1.5V15ZM4.5 8.25H6.5V6.25H4.5V8.25ZM7.5 15H9.5V13H7.5V15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInventory);
export default __webpack_public_path__ + "static/media/icon-inventory.b2a9bd337bc1b783a2814ef6fb8f1ad8.svg";
export { ForwardRef as ReactComponent };